// Pure helpers to keep components free of nested ternaries.

// Service card column span by position in the bento grid.
const SERVICE_SPANS = [
  "md:col-span-7",
  "md:col-span-5",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-12",
];

export function getServiceSpan(index) {
  return SERVICE_SPANS[index] ?? "md:col-span-6";
}

// Progress dot class for the booking step bar.
export function getStepDotClass(n, currentStep) {
  if (n === currentStep) return "w-12 bg-[var(--accent)]";
  if (n < currentStep) return "w-6 bg-[var(--primary)]";
  return "w-6 bg-[var(--border)]";
}

// Lang switcher pill class.
export function getLangPillClass(code, currentLang) {
  if (code === currentLang) return "bg-[var(--primary)] text-white";
  return "text-[var(--muted)] hover:text-[var(--heading)]";
}
